import {Component, inject, input, OnInit} from '@angular/core';
import {NgOptimizedImage} from '@angular/common';
import {MobileOptimizationService} from '../../../core/services/mobile-optimization.service';

@Component({
    selector: 'app-optimized-image',
    standalone: true,
    imports: [NgOptimizedImage],
    template: `
        <img
                [ngSrc]="src()"
                [alt]="alt()"
                [width]="calculatedWidth"
                [height]="calculatedHeight"
                [priority]="priority()"
                [loaderParams]="{
                    fit: fit(),
                    format: 'webp',
                    quality: calculatedQuality
                }"
                [loading]="priority() ? undefined : loading()"
                [class]="className() || ''"
        />
    `,
    styles: [`
      :host {
        display: block;
        width: 100%;
      }

      img {
        max-width: 100%;
        height: auto;
        display: block;
      }
    `]
})
export class OptimizedImageComponent implements OnInit {
    src = input.required<string>();
    alt = input.required<string>();
    width = input.required<number>();
    height = input.required<number>();
    priority = input(false);
    fit = input<string>('cover');
    quality = input<number>(80);
    className = input<string>('');
    loading = input<'lazy' | 'eager'>('lazy');
    calculatedWidth: number = 0;
    calculatedHeight: number = 0;
    calculatedQuality: number = 80;
    private mobileOptimizationService = inject(MobileOptimizationService);

    ngOnInit() {
        // Calculate optimized dimensions and quality based on device
        this.calculatedWidth = this.mobileOptimizationService.getImageWidth(this.width());

        // Maintain aspect ratio
        const aspectRatio = this.width() / this.height();
        this.calculatedHeight = Math.round(this.calculatedWidth / aspectRatio);

        // Set quality based on device and connection
        this.calculatedQuality = this.mobileOptimizationService.getImageQuality();

        // Override with user-specified quality if provided
        if (this.quality() !== 80) {
            this.calculatedQuality = this.quality();
        }
    }
}
